import { createRoot } from 'react-dom/client';
import './styles.css';

const root = document.getElementById('root');

if (root) {
  const page = window.location.pathname === '/admin' ? import('./AdminPage') : import('./App');
  void page.then(({ default: Page }) => createRoot(root).render(<Page />));
}
